import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import ContactForm7 from '../components/contact-form7'
import Footer from '../components/footer'
import './contact.css'

const Contact = (props) => {
  return (
    <div className="contact-container1">
      <Helmet>
        <title>Contact - California Places</title>
        <meta property="og:title" content="Contact - California Places" />
        <link
          rel="canonical"
          href="https://copy-of-glass-outstanding-chamois-m7jub6.teleporthq.app/contact"
        />
        <meta
          property="og:url"
          content="https://copy-of-glass-outstanding-chamois-m7jub6.teleporthq.app/contact"
        />
      </Helmet>
      <div className="contact-container2">
        <Navigation
          button={
            <Fragment>
              <span className="contact-text1">Contact Us</span>
            </Fragment>
          }
          button1={
            <Fragment>
              <span className="contact-text2">Pricing</span>
            </Fragment>
          }
          rootClassName="navigationroot-class-name1"
        ></Navigation>
      </div>
      <ContactForm7></ContactForm7>
      <Footer></Footer>
    </div>
  )
}

export default Contact
